<div class="empty-state">
  <div class="mat-headline-4 announcement-setup-title">
    {{ "ONSIP_I18N.CREATE_YOUR_FIRST_ANNOUNCEMENT" | translate }}
  </div>
  <div class="mat-body-2 announcement-setup-text">
    {{
      "ONSIP_I18N.ANNOUNCEMENTS_WILL_PLAY_A_RECORDING_AND_THEN_TRANSFER_THE_CALLER_SOMEWHERE_ELSE_OR_HANGUP"
        | translate
    }}
  </div>
  <button
    mat-flat-button
    [routerLink]="viewsLink"
    color="primary"
    class="announcements-setup-button"
  >
    {{ "ONSIP_I18N.ADD_ANNOUNCEMENT" | translate }}
  </button>
  <div class="mat-body-2 announcement-pricing">
    {{ pricingText }}
  </div>
</div>
